export default {
  'claimant.firstName': 'Nombre del Reclamante',
  'claimant.lastName': 'Apellido del Reclamante',
  'claimNumber': 'Numero de Reclamo',
  'roadHazardId': 'Identificación de Peligro en la Carretera',
  'invoiceNumber': 'Factura #',
  'dealerId': 'Négociant',
};